import { Glyph } from './Glyph';
import type { CSSProperties, ReactNode } from 'react';
import { cx } from '../cx';

/** Fotografia com proporção fixa e fallback editorial (sem imagem = bloco escuro com textura). */
export function Figure({ src, alt = '', ratio = '4 / 3', radius = 'md', className, children, style, onClick }: { src?: string | null; alt?: string; ratio?: string; radius?: 'sm' | 'md' | 'lg' | 'none'; className?: string; children?: ReactNode; style?: CSSProperties; onClick?: () => void }) {
  return (
    <div className={cx('rr-figure', `rr-figure--${radius}`, !src && 'rr-figure--empty', onClick && 'rr-figure--click', className)} style={{ aspectRatio: ratio, ...style }} onClick={onClick} role={onClick ? 'button' : undefined}>
      {src ? <img className="rr-figure__img" src={src} alt={alt} loading="lazy" /> : <span className="rr-figure__mark" aria-hidden><Glyph name="campo" style={{ width: '46%', maxWidth: 44, height: 'auto', aspectRatio: '1' }} /></span>}
      {children && <div className="rr-figure__over">{children}</div>}
    </div>
  );
}

/** Miniatura quadrada/retangular para linhas de lista. */
export function Thumb({ src, size = 56, ratio = '1 / 1', className }: { src?: string | null; size?: number; ratio?: string; className?: string }) {
  return <Figure src={src} ratio={ratio} radius="sm" className={cx('rr-thumb', className)} style={{ width: size, flexShrink: 0 }} />;
}
